<template>
  <div class="three-gltf"></div>
</template>

<script>
import GLTFLoader from 'three-gltf-loader'

import Object3DMixin from '@/components/threejs/objects/Object3DMixin'

export default {
  name: 'ThreeGLTF',
  mixins: [Object3DMixin],
  created () {
    const loader = new GLTFLoader()

    loader.load(
      // resource URL
      this.node.url,
      // called when the resource is loaded
      (gltf) => {
        this.object3d.add(gltf.scene)
        this.$emit('loaded', this.node)
        // gltf.animations // Array<THREE.AnimationClip>
        // gltf.scene // THREE.Scene
        // gltf.scenes // Array<THREE.Scene>
        // gltf.cameras // Array<THREE.Camera>
        // gltf.asset // Object
      },
      // called while loading is progressing
      (xhr) => {
        console.log((xhr.loaded / xhr.total * 100) + '% loaded')
      },
      // called when loading has errors
      (error) => {
        console.log(error)
        console.log('Error loading model')
        this.$emit('error', this.node)
      }
    )
  }
}
</script>

<style>

</style>
